import api from "@/plugins/axios";

const actions = () => ({
  async fetchDashboardStats() {
    const response = await api.get("/api/stats/dashboard");
    this.dashboard = response.data;
  },
});

export default actions;
